// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const matrixInThresholdMax = 99;

export const MatrixIn = zod.object({
  "threshold": zod.int().min(1).max(matrixInThresholdMax)
});

export type MatrixIn = zod.input<typeof MatrixIn>;
export type MatrixInOutput = zod.output<typeof MatrixIn>;
